import { render } from "./M2ChartJs.vue?vue&type=template&id=0167bc2e&scoped=true"
import script from "./M2ChartJs.vue?vue&type=script&lang=js"
export * from "./M2ChartJs.vue?vue&type=script&lang=js"

import "./M2ChartJs.vue?vue&type=style&index=0&id=0167bc2e&scoped=true&lang=css"
import "./M2ChartJs.vue?vue&type=style&index=1&id=0167bc2e&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0167bc2e"]])

export default __exports__